/// <summary>
/// This object provides js functions for ticket accounting list <br/>
/// <br/>
/// Author: AFU<br />
/// Date: 16.12.2024<br />
/// Copyright ©: EUDT GmbH 2024 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 14.1.2025                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.TicketAccountingList", jQuery.common.vcBaseV4, {
    contentSize: { w: 0, h: 0 },
    lastTicket: {id:0, charge:0, internal: 0, km:0, arrival:0},
    myStatus: {
        dateRange: { from: "", to: "" },
        useDateRange: true
    },
    _create: function () {
        this._createVisual(370);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
           
            me._setRoot(".ticket-account");
            me.myStatus.dateRange.from = moment(Date.now()).add(-30, 'days').format("DD.MM.YYYY");
            me.myStatus.dateRange.to = moment(Date.now()).format("DD.MM.YYYY"); 
            me._buildHtml();
            me._setHeightsAndWidths();
        } catch (e) { me._writeErr(e); return false;} 
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            me._initStructure();
            me._fetch();
        } catch (e) { me._writeErr(e);return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {
            me.myHtml = { menu: {}, filter: {}, list: {} };

            me.myRoot;

            let obj = me.myHtml.menu;
            obj.wrapper = me._setObj("", "vc-grid-margin-bottom").css("width", "100%").css("height", "80px");
            obj.reload = me._setMainButton("reload", me.specific.resources.iconReload, me.specific.resources.reload).addClass("active");            
            obj.filterType = me._setObj("ddlType", "optionbox vc-grid-2col float-box vc-grid-margin-right");


            // OrderType filter box (checkboxes)
            obj.orderTypeFilter = me._setObj("orderTypeFilter", "optionbox vc-grid-2col float-box vc-grid-margin-right").css("margin-left", "15px");
            obj.orderTypeFilterWrapper = me._setObj("", "order-type-filter-wrapper").css({ display: "flex", flexDirection: "column", height: "100%" });
            obj.orderTypeFilterTitle = me._setObj("", "order-type-filter-title").text(me.specific.resources.orderType).css({ fontWeight: "600", marginBottom: "12px", lineHeight: "14px" });

            obj.orderTypeFilterBox = me._setObj("orderTypeFilterBox", "order-type-filter-box").css({
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    columnGap: "14px",
                    rowGap: "10px",
                    alignItems: "start",
                    height: "calc(100% - 30px)",
                });

            // build 3 columns (2 rows) layout
            obj.orderTypeFilterCol1 = me._setObj("", "order-type-filter-col").css({ display: "contents" });
            obj.orderTypeFilterCol2 = me._setObj("", "order-type-filter-col").css({ display: "contents" });
            obj.orderTypeFilterCol3 = me._setObj("", "order-type-filter-col").css({ display: "contents" });

            // TicketEngine.OrderTypes IDs:
            // -1 = no entry, 1 = good will, 2 = guaranty, 3 = invoiced, 4 = flat rate (all-in), 5 = license fee
            obj.chbNoEntry = $('<input type="checkbox" class="chb-order-type" id="chb-ot-noentry" />').prop("checked", true).data("id", -1);
            obj.chbInvoiced = $('<input type="checkbox" class="chb-order-type" id="chb-ot-invoiced" />').prop("checked", true).data("id", 3);
            obj.chbGoodWill = $('<input type="checkbox" class="chb-order-type" id="chb-ot-goodwill" />').prop("checked", true).data("id", 1);
            obj.chbGuaranty = $('<input type="checkbox" class="chb-order-type" id="chb-ot-guaranty" />').prop("checked", true).data("id", 2);
            obj.chbFlatRate = $('<input type="checkbox" class="chb-order-type" id="chb-ot-flatrate" />').prop("checked", true).data("id", 4);
            obj.chbLicenseFee = $('<input type="checkbox" class="chb-order-type" id="chb-ot-licensefee" />').prop("checked", true).data("id", 5);

            obj.lblNoEntry = $('<label for="chb-ot-noentry" class="chb-order-type-lbl"></label>').text(me.specific.resources.noEntry || "no entry");
            obj.lblInvoiced = $('<label for="chb-ot-invoiced" class="chb-order-type-lbl"></label>').text(me.specific.resources.invoiced || "invoiced");
            obj.lblGoodWill = $('<label for="chb-ot-goodwill" class="chb-order-type-lbl"></label>').text(me.specific.resources.goodWill || "good will");
            obj.lblGuaranty = $('<label for="chb-ot-guaranty" class="chb-order-type-lbl"></label>').text(me.specific.resources.guaranty || "guaranty");
            obj.lblFlatRate = $('<label for="chb-ot-flatrate" class="chb-order-type-lbl"></label>').text(me.specific.resources.flatRate || "flat rate");
            obj.lblLicenseFee = $('<label for="chb-ot-licensefee" class="chb-order-type-lbl"></label>').text(me.specific.resources.licenseFee || "license fee");

            obj.rowNoEntry = me._setObj("", "order-type-filter-item").css({ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }).append(obj.chbNoEntry, obj.lblNoEntry);
            obj.rowInvoiced = me._setObj("", "order-type-filter-item").css({ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }).append(obj.chbInvoiced, obj.lblInvoiced);
            obj.rowGoodWill = me._setObj("", "order-type-filter-item").css({ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }).append(obj.chbGoodWill, obj.lblGoodWill);
            obj.rowGuaranty = me._setObj("", "order-type-filter-item").css({ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }).append(obj.chbGuaranty, obj.lblGuaranty);
            obj.rowFlatRate = me._setObj("", "order-type-filter-item").css({ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }).append(obj.chbFlatRate, obj.lblFlatRate);
            obj.rowLicenseFee = me._setObj("", "order-type-filter-item").css({ display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }).append(obj.chbLicenseFee, obj.lblLicenseFee);



            // row 1
            obj.rowNoEntry.css({ gridColumn: 1, gridRow: 1 });
            obj.rowGoodWill.css({ gridColumn: 2, gridRow: 1 });
            obj.rowFlatRate.css({ gridColumn: 3, gridRow: 1 });

            // row 2
            obj.rowInvoiced.css({ gridColumn: 1, gridRow: 2 }).css({ marginTop: "6px" });
            obj.rowGuaranty.css({ gridColumn: 2, gridRow: 2 }).css({ marginTop: "6px" });
            obj.rowLicenseFee.css({ gridColumn: 3, gridRow: 2 }).css({ marginTop: "6px" });

            obj.orderTypeFilterBox.append(obj.rowNoEntry, obj.rowGoodWill, obj.rowFlatRate, obj.rowInvoiced, obj.rowGuaranty, obj.rowLicenseFee);

            obj.orderTypeFilterWrapper.append(obj.orderTypeFilterTitle, obj.orderTypeFilterBox);
            obj.orderTypeFilter.append(obj.orderTypeFilterWrapper);



            // accounter filter 
            obj.filterAccounter = me._setObj("ddlAccounterFilter", "optionbox vc-grid-2col float-box vc-grid-margin-left vc-grid-margin-right");

            // init dropdown for accounter filter
            obj.ddlAccounter = $('<select />').css("width", "100%");
            $('<option />', { value: -1, text: (me.specific.resources.all || "Alle") }).appendTo(obj.ddlAccounter);

            var users = JSON.parse(me.specific.ddlUsers || "[]");
            for (var i = 0; i < users.length; i++) {
                $('<option />', { value: users[i].Id, text: users[i].Name }).appendTo(obj.ddlAccounter);
            }

            obj.ddlAccounter.val(-1);                    


            obj.date = me._setObj("date", "optionbox vc-grid-2col float-box");           
            obj.wrapper.append(obj.reload, obj.filterType, obj.orderTypeFilter, obj.filterAccounter, obj.date);

            obj.date.hide();



            //create the dropdown for the filter type
            obj.ddlFilter = $('<select />').css("width", "100%");
            $('<option />', { value: 1, text: me.specific.resources.allUnbilledEntries }).appendTo(obj.ddlFilter);
            $('<option />', { value: 2, text: me.specific.resources.showAllEntries }).appendTo(obj.ddlFilter);
            $('<option />', { value: 3, text: me.specific.resources.closeTicketsOnly }).appendTo(obj.ddlFilter);
            $('<option />', { value: 4, text: me.specific.resources.permanentTicketsOnly }).appendTo(obj.ddlFilter);
            $('<option />', { value: 5, text: me.specific.resources.nonBillableTicketsOnly }).appendTo(obj.ddlFilter);
            $('<option />', { value: 6, text: me.specific.resources.showAllEntries + " (" + me.specific.resources.withoutActivities + ")" }).appendTo(obj.ddlFilter);
            obj.ddlFilter.val(1);


            //filter with new button 
            obj = me.myHtml.filter;
            obj.wrapper = me._setWrapper("", "").css({ display: "flex", alignItems: "center" /*"flex-end"*/, width: "100%" });
            obj.filter = me._setObj("filter", "vc-filter vc-grid-2col float-box");

            obj.dateRangeToggle = me._setObj("dateRangeToggle", "optionbox vc-grid-2col float-box vc-grid-margin-left").css({ display: "flex", alignItems: "center", gap: "8px" });
            var label = $('<span class="chb-lbl-date-range"></span>').text(me.specific.resources.selectTimePeriod);
            var input = $('<input type="checkbox" class="chb-date-range" id="chb-date-range" />').css({ marginLeft: "8px" });
            obj.dateRangeToggle.append(input, label);

            obj.wrapper.append(obj.filter, obj.dateRangeToggle);

            obj = me.myHtml.list;
            obj.wrapper = me._setObj("", "vc-list");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w3").html("<br/>"));
            line.column.append(me._setListElement("", "w25").html(me.specific.resources.ticket));
            line.column.append(me._setListElement("", "w7").html(me.specific.resources.state));
            line.column.append(me._setListElement("", "w10").html(me.specific.resources.accounter));
            line.column.append(me._setListElement("", "w15").html(me.specific.resources.project));
            line.column.append(me._setListElement("", "w20").html(me.specific.resources.order));
            line.column.append(me._setListElement("", "w7").html(me.specific.resources.accounting));
            line.column.append(me._setListElement("", "w7").html(me.specific.resources.orderType));
            line.column.append(me._setListElement("", "w5").html(me.specific.resources.activities));
            obj.header.append(line.item);

            obj.entries = me._setObj("entries", "vc-list-table").css("max-height", "none");

            obj.header.css("position", "relative");
            obj.header.css("z-index", "2");

            obj.entries.css("position", "relative");
            obj.entries.css("z-index", "1");

            var tmp = $("<div>").addClass("color-bg-secondary").appendTo(document.body);
            var borderColor = window.getComputedStyle(tmp.get(0)).backgroundColor;
            tmp.remove();

            // add border to first item, otherwise we have an edge due to the padding-right for the scrollbar
            obj.header.find(".vc-list-item").first().css("border-bottom", "1px solid " + borderColor);


            obj.wrapper.append(obj.header, obj.entries);


            me.myRoot.append(me.myHtml.menu.wrapper, me.myHtml.filter.wrapper, me.myHtml.list.wrapper);


        } catch (e) {me._writeErr(e);return false;}
        return true;
    },


    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {


            me.myHtml.filter.filter.vcFilter({ callback: function () { me._filter(); } });

            ////init vcDate 
            me.myHtml.menu.date.vcDateBox({ mode: "Range", align: "right", interval: 1, langID: me.settings.userLangIDForCulture, defaultRange: me.myStatus.dateRange, callback: function (obj) { me.myStatus.dateRange = obj.dateRange; } });

            me.myHtml.menu.filterType.vcOptionBox({
                caption: me.specific.resources.selection,
                items: [{ button: me.specific.resources.selection, clickable: false, isList: true, content: me.myHtml.menu.ddlFilter }]
            });


            // accounter filter optionbox
            me.myHtml.menu.filterAccounter.vcOptionBox({
                caption: me.specific.resources.selection,
                items: [{ button: me.specific.resources.accounter, clickable: false, isList: true, content: me.myHtml.menu.ddlAccounter }]
            });

            if (typeof me._initSelectize === "function") {
                me.ddlAccounter = me._initSelectize(me.myHtml.menu.ddlAccounter, JSON.parse(me.specific.ddlUsers || "[]"), true);
                me.ddlAccounter.setValue(-1, true);
            }


            // init order type checkbox filter
            me.myHtml.menu.orderTypeFilter.find(".chb-order-type").off("change").on("change", function () {
                me.myStatus.orderTypeIds = me._getSelectedOrderTypeIds();
            });


            if (!me.myStatus.useDateRange) {
                me.myHtml.menu.date.hide();
            }

            me.myHtml.filter.dateRangeToggle.find("#chb-date-range").off('change').on('change', function () {
                me.myStatus.useDateRange = jQuery(this).is(':checked');
                if (me.myStatus.useDateRange) {
                    me.myHtml.menu.date.show();
                } else {
                    me.myHtml.menu.date.hide();
                }
            });

            //init reload button
            me.myHtml.menu.reload.off("click").on("click", function () { me._fetch(); });

            me.myHtml.list.entries.off("click", ".fa-print").on("click", ".fa-print", function (e) {
                e.preventDefault(); // prevent opening the ticket dialog
                e.stopPropagation();

                window.open(window.location.origin + '/' + window.location.pathname.split('/')[1] + '/html/share/Ticket.aspx?id=' + parseInt($(this).data("tid")) + '&blid=' + parseInt($(this).data("blid")) + '&lang=' + me.settings.userLangIDForCulture + '&accounting=true', '_blank');
            });


            // click handler for opening the ticket dialog by clicking directly on the row
            me.myHtml.list.entries.off("click", ".vc-list-item").on("click", ".vc-list-item", function (e) {

                if ($(e.target).closest(".fa-print").length > 0) return; // to ensure that the print icon click does not trigger this event

                var blid = parseInt($(this).attr("data-blid"));
                var tid = parseInt($(this).attr("data-tid"));

                if (isNaN(blid) || isNaN(tid)) return;

                me.vcV.showSingleTicketDialog(blid, { "TicketID": tid, readOnlyMode: false, accountingMode: true });
            });


            me.myHtml.list.entries.off("click", ".fa-pen").on("click", ".fa-pen", function (e) {
                me.vcV.showSingleTicketDialog(parseInt($(this).data("blid")), { "TicketID": parseInt($(this).data("tid")), readOnlyMode: false, accountingMode: true });
            });

        } catch (e) { me._writeErr(e); }
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current settings
        /// </summary>
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.list.entries);

            var filterType = parseInt(me.myHtml.menu.ddlFilter.val());
            var useDateRange = me.myHtml.filter.dateRangeToggle.find("#chb-date-range").is(':checked');
            me.myStatus.useDateRange = useDateRange;


            var accounterId = -1;

            // if selectize is used
            if (me.ddlAccounter && typeof me.ddlAccounter.getValue === "function") {
                var v = me.ddlAccounter.getValue();
                accounterId = (v && v.length > 0) ? parseInt(v) : -1;
            } else {
                accounterId = parseInt(me.myHtml.menu.ddlAccounter.val());
                if (isNaN(accounterId)) accounterId = -1;
            }


           
            var param = { TypeId: 1, FilterTypeID: filterType, UseDateRange: useDateRange, StartDate: null, EndDate: null, OrderTypeIds: me._getSelectedOrderTypeIds(), AccounterId: accounterId };
            if (useDateRange) {
                param.StartDate = me.myStatus.dateRange.from;
                param.EndDate = me.myStatus.dateRange.to;
            }

            me.getData(param, function (result) {
                
                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true); return true;
                }
                me.myData = result;
                me._generateList();
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {
           
            if (me.myData.rows === null || me.myData.rows === undefined) {
                me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            //clear list
            me.myHtml.list.entries.html("");
            me.lastTicket.id = 0;
            
            // fill entry list
            for (i = 0; i < me.myData.rows.length; i++) {
                me._fillRow(me.myData.rows[i]);
            };


            me._filter();

            me._setAltListStyle(me.myHtml.list.entries);

            // we sync the header width to the entries width
            me._syncListHeaderToEntries(me.myHtml.list.header, me.myHtml.list.entries);
            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _fillRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            var line = me._setListItem();
            line.item.attr("data-tid", row.tid); // we need this for opening the ticket dialog
            line.item.attr("data-blid", row.blid);

            line.column.append(me._setListElement("", "w3").html("<i class='fa fa-lg fa-print icon-color-info vc-grid-icon vc-grid-margin-right' data-tid='" + row.tid + "'  data-blid='" + row.blid + "' ></i><i class='fa fa-pen icon-color-info vc-grid-icon'  data-tid='" + row.tid + "'  data-blid='" + row.blid + "' ></i>"));
            line.column.append(me._setListElement("", "w25").html("T" + row.tid + ": " + row.tproject + " - " + row.name));
            line.column.append(me._setListElement("", "w7").html(row.ticketState));

            var person = (row.person !== null && row.person !== undefined && ("" + row.person).length > 0) ? row.person : "&nbsp;";
            line.column.append(me._setListElement("", "w10").html(person));

            line.column.append(me._setListElement("", "w15").html(row.tproject));
            line.column.append(me._setListElement("", "w20").html((row.order !== null ? row.order : "") + "<br/>"));
            line.column.append(me._setListElement("", "w7").html((row.accountingtime !== null ? row.accountingtime : "") + "<br/>"));

            var ot = (row.orderType !== null && row.orderType !== undefined && ("" + row.orderType).length > 0) ? row.orderType : "&nbsp;";
            line.column.append(me._setListElement("", "w7").html(ot));

            var actStr = row.activities;
            if (row.nonbilled_activities !== undefined && row.nonbilled_activities !== null) {
                actStr += " / " + row.nonbilled_activities;
            }
            
            line.column.append(me._setListElement("", "w5").css("text-align", "center").html(actStr));
            me.myHtml.list.entries.append(line.item);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },


    _filter: function () {

        this._doListTableFilter(this.myHtml.list.entries);
    },

    _getSelectedOrderTypeIds: function () {
        /// <summary>
        /// Returns the selected order type ids based on the checkboxes in the menu.
        /// </summary>
        var me = this;
        try {
            var ids = [];
            if (!me.myHtml || !me.myHtml.menu || !me.myHtml.menu.orderTypeFilter) return ids;

            me.myHtml.menu.orderTypeFilter.find(".chb-order-type:checked").each(function () {
                var id = parseInt($(this).data("id"));
                if (isNaN(id)) return true;
                ids.push(id);
            });

            return ids;
        } catch (e) { me._writeErr(e); return []; }
    },

    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            let hList = me._getVisualHeight() - me.myHtml.menu.wrapper.outerHeight() - me.myHtml.filter.wrapper.outerHeight() - 20;

            me.myHtml.list.wrapper.css("height", hList);
            hList -= me.myHtml.list.header.outerHeight();
            me.myHtml.list.entries.css("max-height", hList);

            // we sync the header width to the entries width
            me._syncListHeaderToEntries(me.myHtml.list.header, me.myHtml.list.entries);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.menu.wrapper.hide();
                me.myHtml.filter.wrapper.hide();
                me.myHtml.list.wrapper.hide();
            }
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    }
});